export const LATEST_TAB = 'all';
export const NEED_APPROVAL_TAB = 'pending';
export const HIDDEN_TAB = 'hidden';
export const APPROVED_TAB = 'approved';
